module.exports = __webpack_public_path__ + "img/athletics_icon_14.7164716c.png";